// store/surveyCountries.js
import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: [],
    forSurvey: {}, // surveyUuid -> [countries]
  },
  mutations: {
    SET_ALL(state, list)       { state.all = list },
    SET_SURVEY(state, { id, list }) { state.forSurvey[id] = list }
  },
  actions: {
    fetchAll({ commit }) {
      return axios.get('/countries')
        .then(({data}) => commit('SET_ALL', data));
    },
    fetchForSurvey({ commit }, surveyId) {
      return axios.get(`/surveys/${surveyId}/countries`)
        .then(({data}) => commit('SET_SURVEY', { id: surveyId, list: data }));
    },
    addToSurvey({ dispatch }, { surveyId, country }) {
      return axios.post(`/surveys/${surveyId}/countries`, { country_uuid: country.uuid })
        .then(() => dispatch('fetchForSurvey', surveyId));
    },
    removeFromSurvey({ dispatch }, { surveyId, country }) {
      return axios.delete(`/surveys/${surveyId}/countries/${country.uuid}`)
        .then(() => dispatch('fetchForSurvey', surveyId));
    },
  }
}
